
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/user/inventory/apostle/list",
      function () {
        return require("private-next-pages/user/inventory/apostle/list.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/user/inventory/apostle/list"])
      });
    }
  